import { takeEvery, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import {
  createReviewsSurvey,
  updateReviewsSurvey,
  publishReviewsSurvey,
  doneReviewsSurveyByIdForUser,
  doneReviewsSurveyByIdForReviewer,
} from 'store/entities/reviewsSurveys/actions'

// * USAGE *
// just add 'redirect; field to action-request

export function* handleRunRedirectSaga({ meta }: { type: string; payload: any; meta: any }) {
  if (meta.redirect) {
    yield put(push(meta.redirect))
  }
}

export default function* runRedirectSaga() {
  yield takeEvery(
    [
      createReviewsSurvey.success.toString(),
      updateReviewsSurvey.success.toString(),
      publishReviewsSurvey.success.toString(),
      doneReviewsSurveyByIdForUser.success.toString(),
      doneReviewsSurveyByIdForReviewer.success.toString(),
    ],
    handleRunRedirectSaga
  )
}
